import { FEEDBACK_SET_LIST, FEEDBACK_SET_QUESTIONS } from './actionTypes';

const defaultState = {
  list: null,
  questions: null,
};

export function feedback(state = defaultState, action) {
  const { type, payload } = action;
  switch (type) {
    case FEEDBACK_SET_LIST:
      return { ...state, list: payload };

    case FEEDBACK_SET_QUESTIONS: {
      return { ...state, questions: payload };
    }

    default:
      return state;
  }
}
